export default __webpack_public_path__ + "static/media/mpudt.77a08416.png";